/**
 * @file use-mobile.js
 * @description Hook para detectar se o dispositivo é mobile (CRA)
 */

import { useState, useEffect } from "react"

const MOBILE_BREAKPOINT = 768

/**
 * Hook para detectar se o dispositivo é mobile (atualiza ao redimensionar ou ao cruzar o breakpoint).
 * @returns {boolean} true se for mobile
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
    const query = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`
    const mql = window.matchMedia(query)

    const syncMobile = () => {
      setIsMobile(mql.matches)
    }

    syncMobile()

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", syncMobile)
    } else if (typeof mql.addListener === "function") {
      mql.addListener(syncMobile)
    }

    window.addEventListener("resize", syncMobile)

    return () => {
      if (typeof mql.removeEventListener === "function") {
        mql.removeEventListener("change", syncMobile)
      } else if (typeof mql.removeListener === "function") {
        mql.removeListener(syncMobile)
      }
      window.removeEventListener("resize", syncMobile)
    }
  }, [])

  // Retorna false durante SSR para evitar problemas de hidratação
  if (!isClient) return false

  return isMobile
}

// Alias para compatibilidade
export function useMobile() {
  return useIsMobile()
}
